import {isAnURL} from 'lib/validator'
import {map} from 'lodash/collection'
import nesProp from 'nested-property'
import {signatureTemplate} from './signatureTemplate.coffee'
import underscore from 'underscore'
import i18n from 'lib/i18n'
import md5 from 'md5'
const _ = i18n('office')

// TODO Here is defined the service url for getting broker logo, but we have to provide it from a common place.
//const URL_BROKER_LOGO = window.location.protocol+'//'+window.location.hostname+'/brokerLogo?brokerNumber='
const URL_BROKER_LOGO =  window.location.protocol+'//'+window.location.href.split("/")[2]+'/brokerLogo?brokerNumber='
const LOGO_PLACEHOLDER_URL = window.location.protocol+'//'+window.location.href.split("/")[2]+'/uploads/brokerLogos/'
const LOGO_PLACEHOLDER_TRANSPARENT = 'logoPlaceholder.png'
const LOGO_PLACEHOLDER_EN = 'placeOfLogoEn.png'
const LOGO_PLACEHOLDER_FR = 'placeOfLogoFr.png'
const LOGO_PLACEHOLDER_NL = 'placeOfLogoNl.png'
const logoPlaceHolderNl = LOGO_PLACEHOLDER_URL+LOGO_PLACEHOLDER_NL
const logoPlaceHolderFr = LOGO_PLACEHOLDER_URL+LOGO_PLACEHOLDER_FR
const logoPlaceHolderEn = LOGO_PLACEHOLDER_URL+LOGO_PLACEHOLDER_EN
const logoPlaceHolderTransparent = LOGO_PLACEHOLDER_URL+LOGO_PLACEHOLDER_TRANSPARENT

/**
 * This will update signature for brokers who don't has right to update the signature
 *
 * @param {*} theBroker
 * @param {*} userId
 * @param {*} userFullName
 * @param {*} lang
 */
const signatureGenerator = (theBroker, userId, userFullName, lang) => {

    if (!theBroker || !theBroker.main) {
        return ''
    }

    // wait with html processing until the logo is cached
    let workOnLogoAndReplacementsPromise = new Promise( async (resolve, reject) => {
        let noCache = true
        const promiseForLogoLink = await getLogoLinkPromise(theBroker.brokerNumber, lang, noCache)
        let replacements = generateSignatureReplaceData(theBroker, userId, userFullName, lang)

        replacements.URL_BROKER_LOGO = promiseForLogoLink

        return resolve(parseAndReplaceVariables(signatureTemplate, replacements))
    })

    return workOnLogoAndReplacementsPromise
}

/**
 * Generates the replacement data for the signature
 * @param {*} theBroker
 * @param {*} userId
 * @param {*} userFullName
 * @param {*} lang
 * @return {object|null} null if the required data was not found
 */
export const generateSignatureReplaceData = (theBroker, userId, userFullName, lang) => {
    if (!theBroker || !theBroker.main) {
        return null
    }
    const brNr = theBroker.brokerNumber
    const main = theBroker.main
    const employees = theBroker && theBroker.staff
    const userName = findUserNameInBrokersStuffByUserId(userId, employees) || userFullName || "--"

    // select the correspondanceAddress if exists else mainAddress.
    // (the "correspondance" is misspelled because must be "correspondence" not affect functionality
    // if nobody does not change it)
    let address = nesProp.get(main, "correspondanceAddress")
    if (!address || Object.keys(address).length === 0
        || Object.keys(address).filter((oneProp) => (address[oneProp])).length === 0) {
        address = nesProp.get(main, "mainAddress")
    }

    const addressExtension = address.extension ? `/${address.extension}` : ''
    //const addressBus = address.bus ? `/${address.bus}` : ''
    let fullAddress = ''
    if (address.street || address.number || addressExtension || address.postalCode || address.locality) {
        fullAddress = (`${address.street} ${address.number}${addressExtension}, ${address.postalCode} ${address.locality}`)
    }

    const website = isAnURL(main.website) ? '<a href="'+main.website+'" target="_blank" rel="noopener noreferrer">'+main.website+'</a>' : main.website
    const emails = map(main.emails, (email, i) => (email ? '<a href="mailto:'+email+'">'+email+'</a>' : ''))
    const phoneNumbers = map(main.phoneNumbers, (phoneNumber, i) => (phoneNumber ? '<a href="tel:'+phoneNumber+'">'+phoneNumber+'</a>' : ''))
    const firstPhone = nesProp.get(phoneNumbers, '0')
    const fax = main.faxNumber ? ('<a href="tel:'+main.faxNumber+'">'+main.faxNumber+'</a>') : ''
    // const promiseForLogoLink = getLogoLinkPromise(brNr, lang)

    // this is a list of variable what you can use in the template to replace it
    let replacements = {
        URL_BROKER_LOGO: URL_BROKER_LOGO+brNr,
        name: userName, //main.name,
        commercialName: (main.commercialName || main.name), // commercialName if not empty, else office name //+'('+brNr+')'
        fullAddress: fullAddress,
        emails: nesProp.get(emails, '0') ? _('email') + ': ' + nesProp.get(emails, '0') : '', //emails.join('; '),
        website: (website && website !== 'http://') ? (_('website') + ': ' + website) : '',
        // the default phone number, now the first one is the default
        // phoneNumbers: _('telephone') + ': ' + phoneNumbers.filter((number,index)=>(index==0)).join(', '),
        phoneNumbers: firstPhone ? (_('telephone') + ': ' + firstPhone) : '',
        fax: fax ? (_('fax') + ': ' + fax) : '',
        fsma: (_('fsma') + ': ' + main.fsmaNumber),
        companyRegistrationNumber: (" - " +_('companyRegistrationNumber') + ': ' + main.companyRegistrationNumber),
        signatureText: (String(main.signatureText).trim() ? " - " + main.signatureText : ""),

        // template lookout parameters
        faxAndPhoneAdditionalCss: fax || firstPhone ? 'height: auto;' : 'height: 0; display: none;',
        faxAndPhoneSeparator: fax || firstPhone ? '<br/>' : ''
        //aedesNumber: _('aedesNumber') + ': ' + main.aedesNumber //<span style="font-size: 11px;">{{aedesNumber}}</span>
    }

    return replacements
}

/**
 * Generates an md5 hash from the signature replacement data
 * @param {Object} signatureData
 */
export const generateUniqueHashFromSignatureData = (signatureData) => {
    if( signatureData === null) {
        return null
    }

    let jsonString = md5(JSON.stringify(signatureData))
    return jsonString
}

/**
 *
 * @param {*} userId
 * @param {*} employees
 */
const findUserNameInBrokersStuffByUserId = (userId, employees) => {
    let userName = ''

    if (employees && Array.isArray(employees) && employees.length > 0) {
        let oneEmploye = employees.filter((oneEmplItem)=>{
            return oneEmplItem.userId == userId
        })

        if ( oneEmploye && oneEmploye.length > 0 ) {
            let eFirstName = oneEmploye[0].firstName || ""
            let eLastName = oneEmploye[0].lastName || ""
            userName = (eFirstName + " " + eLastName)
            userName = String(userName).trim()
        }
    }

    return userName
}

/**
 *
 * @param {*} signatureTemplate
 * @param {*} keyValues
 */
const parseAndReplaceVariables = (signatureTemplate, keyValues) => {
    const varKeys = Object.keys(keyValues)
    let result = ''
    if (!underscore.isEmpty(varKeys) && varKeys.length > 0 && signatureTemplate) {
        let searchExp = '', replaceExp = ''
        result = String(signatureTemplate)
        varKeys.forEach((varKeyValue) => {
            searchExp = varKeyValue || "unknownvar"
            replaceExp = nesProp.get(keyValues,varKeyValue) || ""
            result =   result.replace(new RegExp("\{\{"+searchExp+"\}\}", 'g'), replaceExp)
        })
    }
    return result
}

/**
 *
 * @param {*} brNr
 */
const getLogoLinkPromise = (brNr, lang, noCache = false) => {
    return new Promise((resolve)=>{
        let logoPlaceholderUrl

        switch (lang) {
            case 'nl':
            logoPlaceholderUrl = logoPlaceHolderNl
                break
            case 'fr':
            logoPlaceholderUrl = logoPlaceHolderFr
                break
            case 'en':
            logoPlaceholderUrl = logoPlaceHolderEn
                break
            default:
            logoPlaceholderUrl = logoPlaceHolderNl
        }

        let request = new XMLHttpRequest()
        let logoUrl = URL_BROKER_LOGO + brNr
        let logoUrlNoCache = logoUrl

        if (noCache){
            logoUrlNoCache = logoUrl + '&noCache=true&rnd=' + Math.floor(Math.random() * 10000000)
        }

        // to enforce the browser for download image
        logoUrl = logoUrl + '&rnd=' + Math.floor(Math.random() * 10000000)

        request.open('GET', logoUrlNoCache, true)
        request.timeout = 10000
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                if (request.status === 404) {
                    resolve(logoPlaceholderUrl)
                } else if (request.status === 200) {
                    resolve(logoUrl)
                }
            }
        }
        request.ontimeout = () => {
            resolve(logoPlaceholderUrl)
        }
        request.send()
    })
}

/**
 * This function do replace for the language depended placeholder logo URL to a transparent placeholder.
 * @param {string} content - the signature content where we want to replace the logo placeholders to be invisible
 * @returns {string} the input string modified version, what contains the invisible placeholder link
 */
export const replacePlaceholderToTransparentLogo = (content) => {
    if (content) {
        content = content.replace(
            logoPlaceHolderEn,
            logoPlaceHolderTransparent
        )

        content = content.replace(
            logoPlaceHolderFr,
            logoPlaceHolderTransparent
        )

        content = content.replace(
            logoPlaceHolderNl,
            logoPlaceHolderTransparent
        )
    }

    return content
}

/**
 * This function do replace for the language depended placeholder logo URL to a nothing.
 * @param {string} content - the signature content where we want to replace the logo placeholders to be invisible
 * @returns {string} the input string modified version, what contains the invisible placeholder link
 */
export const replacePlaceholderToNothing = (content) => {
    if (content) {
        let pattern = new RegExp('<img(.*)src="'+logoPlaceHolderEn+'"(.*)\/>', "g")
        content = content.replace(pattern, '')

        pattern = new RegExp('<img(.*)src="'+logoPlaceHolderFr+'"(.*)\/>', "g")
        content = content.replace(pattern, '')

        pattern = new RegExp('<img(.*)src="'+logoPlaceHolderNl+'"(.*)\/>', "g")
        content = content.replace(pattern, '')
    }

    return content
}

/**
 * This function do replace for the general transparent logo URL to a placeholder to be
 * visible for the broker when edit.
 * @param {string} content - the signature content where we want to replace the invisible logo placeholders
 * @returns {string} the input string modified version, what contains the visible placeholder links
 */
export const replaceTransparentLogoToPlaceholder = (content, lang) => {
    let logoPlaceholderUrl

    switch (lang) {
        case 'nl':
        logoPlaceholderUrl = logoPlaceHolderNl
            break
        case 'fr':
        logoPlaceholderUrl = logoPlaceHolderFr
            break
        case 'en':
        logoPlaceholderUrl = logoPlaceHolderEn
            break
        default:
        logoPlaceholderUrl = logoPlaceHolderNl
    }

    if (content) {
        content = String(content).replace(
            logoPlaceHolderTransparent,
            logoPlaceholderUrl
        )
    }

    return content
}

export default signatureGenerator



// WEBPACK FOOTER //
// ./components/office/signatureGenerator.jsx